import React, { useCallback } from 'react';
import Clickable from '@prisjakt/ui-clickable';
import * as S from '../styles';
import { usePriceRowContext } from '../../../price-row-context';
import { IAlternativePrice } from './types';
import { StockPriceInfo } from '../../components/stock-price-info';
import OptionsColumn from './options-cloumn';
import { GoToStoreButton } from '../../components/go-to-store-button';

const AlternativePriceRow = ({
  alternativeOffer,
  onClickOut,
  tableLinkProps,
}: IAlternativePrice) => {
  const { offer } = usePriceRowContext();
  const { featured } = offer;

  const handleClickOut = useCallback(
    (e: React.MouseEvent) => onClickOut(e, alternativeOffer.id),
    [alternativeOffer.id, onClickOut]
  );

  return (
    <S.AltRow featured={Boolean(featured)}>
      <OptionsColumn
        alternativeOffer={alternativeOffer}
        featured={Boolean(featured)}
      />
      {featured && alternativeOffer.externalUri && (
        <S.ActionArea
          container={Clickable as any}
          containerProps={{
            to: alternativeOffer.externalUri,
            'aria-label': alternativeOffer.name,
            rel: tableLinkProps.rel,
            isExternal: true,
            onMouseDown: tableLinkProps.onMouseDown,
            onTouchStart: tableLinkProps.onTouchStart,
            onKeyDown: tableLinkProps.onKeyDown,
            target: tableLinkProps.target,
            onClick: handleClickOut,
          }}
        >
          <S.Content>
            <S.TopMiddleRow isAlternative featured={featured}>
              <S.ProductNameColumn>
                <S.ProductName featured={featured} isAlternative>
                  {alternativeOffer.name}
                </S.ProductName>
              </S.ProductNameColumn>
              <StockPriceInfo alternativeOffer={alternativeOffer} />
            </S.TopMiddleRow>
            <S.EndColumn featured>
              <GoToStoreButton />
            </S.EndColumn>
          </S.Content>
        </S.ActionArea>
      )}

      {(!featured || !alternativeOffer.externalUri) && (
        <S.Link {...tableLinkProps} onClick={handleClickOut}>
          <S.TopMiddleRow featured={featured}>
            <S.ProductNameColumn featured>
              <S.ProductName featured={Boolean(featured)} isAlternative>
                {alternativeOffer.name}
              </S.ProductName>
            </S.ProductNameColumn>
            <StockPriceInfo alternativeOffer={alternativeOffer} />
          </S.TopMiddleRow>
        </S.Link>
      )}
    </S.AltRow>
  );
};

export default AlternativePriceRow;
